var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessInHos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 17.5C4.5 19.2728 4.84919 21.0283 5.52763 22.6662C6.20606 24.3041 7.20047 25.7923 8.45406 27.0459C9.70765 28.2995 11.1959 29.2939 12.8338 29.9724C14.4717 30.6508 16.2272 31 18 31C19.7728 31 21.5283 30.6508 23.1662 29.9724C24.8041 29.2939 26.2923 28.2995 27.5459 27.0459C28.7995 25.7923 29.7939 24.3041 30.4724 22.6662C31.1508 21.0283 31.5 19.2728 31.5 17.5C31.5 13.9196 30.0777 10.4858 27.5459 7.95406C25.0142 5.42232 21.5804 4 18 4C14.4196 4 10.9858 5.42232 8.45406 7.95406C5.92232 10.4858 4.5 13.9196 4.5 17.5Z",
    stroke: "#5CB85C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 18L16 22L24 14",
    stroke: "#5CB85C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessInHos);
export default __webpack_public_path__ + "static/media/success-in-hos.7a1e5be3497c46d2977229fe55db4c6d.svg";
export { ForwardRef as ReactComponent };